import { http } from "../../utils/http";

export async function getNotificationsTargets() {
  const response = await http("/admin/notifications/targets");
  return response.data;
}
